import Axios from "./axios";

const endpoint = "/api/sms";

export default {
  //현장 발주/출고 번호목록 조회
  //{"urlName": 0}
  smsInfomation: (data) => Axios.post(`${endpoint}/information`, data),

  //문자보내기
  //{"constId": 0,"delimiter": 0,"managerName": "string","orderId": "string","phoneNumber": "string","pushsmsId": 0}
  smsSend: (data) => Axios.post(`${endpoint}/send`, data),

  smsUserList: (data) => Axios.post(`${endpoint}/send-user-list`, data),
};
